import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { MutationConfig } from '@/lib/tanstack-query';

import { PendingTransaction } from '@/types/api/bankid/v2/transaction';
import { getTransactionQueryOptions } from './get-transaction';

export const cancelTransaction = async ({ transactionId }: { transactionId: string }): Promise<PendingTransaction> => {
  return (await api.post(`/bankid/${transactionId}/cancel`)).data;
};

type UseCancelTransactionOptions = {
  mutationConfig?: MutationConfig<typeof cancelTransaction>;
};

export const useCancelTransaction = ({ mutationConfig }: UseCancelTransactionOptions = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (data, vars, ...args) => {
      queryClient.invalidateQueries({ queryKey: getTransactionQueryOptions(vars.transactionId).queryKey });
      onSuccess?.(data, vars, ...args);
    },
    ...restConfig,
    mutationFn: cancelTransaction,
  });
};
